import type { PopoverPosition } from "@mui/material";
import type { ArtifactFigureAnchor } from "@entrilia/shared/artifactRuntime/protocol";
import { clampNumber } from "@entrilia/shared/utilities/numberHelper";

export interface FrameRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export const toAnchorPosition = (anchor: ArtifactFigureAnchor, frame: FrameRect): PopoverPosition => ({
  left: frame.left + clampNumber(anchor.x, 0, frame.width),
  top: frame.top + clampNumber(anchor.y + anchor.height, 0, frame.height),
});
